import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'

const messages = defineMessages({
  welcome: {
    id: 'NewsletterFormSuccess.welcome',
    defaultMessage: 'Welcome to the Gymaholic community'
  },
  checkYourEmail: {
    id: 'NewsletterFormSuccess.checkYourEmail',
    defaultMessage: 'Check your email inbox to verify your account.'
  }
})

export default function NewsletterFormSuccess () {
  const intl = useIntl()

  return (
    <div>
      <h3>{formatMessageIntlUtil(intl, messages.welcome)}</h3>
      <p>{formatMessageIntlUtil(intl, messages.checkYourEmail)}</p>
    </div>
  )
}
